import {
  TEvaluationChartInfoParams,
  TEvaluationChartInfoResponse,
  TEvaluationChartListByPatientParams,
  TEvaluationChartListByRegisteredChartParams,
  TEvaluationChartListByPatientResponse,
  TEvaluationChartListByRegisteredChartResponse,
  TRegisterChartParams,
  TRegisterChartResponse,
  TCheckSamePatientParams,
  TCheckSamePatientResponse,
  TPutEvaluationChartResponse,
} from 'types/apis/chart/studentEvaluationChart';
import { createService } from 'apis/config/axios';
import qs from 'qs';

// 대상자 상세 페이지에서 실습 차트 목록 조회
export const getEvaluationChartListByPatient = async (
  patientId: string,
  params: TEvaluationChartListByPatientParams
) => {
  const queryString = qs.stringify(params);
  const url = `/evaluate-chart/list/${patientId}?${queryString}`;

  return await createService<TEvaluationChartListByPatientResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

// 실습 차트 페이지에서 실습 차트 목록 조회
export const getEvaluationChartListByRegisteredChart = async (
  params: TEvaluationChartListByRegisteredChartParams
) => {
  const queryString = qs.stringify(params);
  const url = `/evaluate-chart/registered-chart?${queryString}`;

  return await createService<TEvaluationChartListByRegisteredChartResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getCheckSamePatient = async (params: TCheckSamePatientParams) => {
  const queryString = qs.stringify(params);
  const url = `/evaluate-chart/check-same-patient?${queryString}`;

  return await createService<TCheckSamePatientResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const postEvaluationChart = async (data: TRegisterChartParams) =>
  await createService<TRegisterChartResponse>({
    url: '/evaluate-chart',
    options: {
      method: 'post',
      data,
    },
  });

export const getEvaluationChartInfo = async (
  params: TEvaluationChartInfoParams
) => {
  const queryString = qs.stringify(params);
  const url = `/evaluate-chart/info?${queryString}`;

  return await createService<TEvaluationChartInfoResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const putEvaluationChartInfo = async (
  evaluationChartId: number,
  data: FormData
) =>
  await createService<TPutEvaluationChartResponse>({
    url: `/evaluate-chart/${evaluationChartId}`,
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'put',
      data,
    },
  });

export const deleteEvaluationChart = async (evaluationChartId: number) =>
  await createService({
    url: `/evaluate-chart/${evaluationChartId}`,
    options: {
      method: 'delete',
    },
  });
